import React from "react";
import "./builds.css";
import { Fade } from "react-reveal";
import { usePortfolioData } from "../../hooks/usePortfolioData";

const Builds = () => {
  const { data, loading } = usePortfolioData();

  if (loading || !data) {
    return (
      <div className="builds-container" id="work">
        <div>Loading...</div>
      </div>
    );
  }

  const featuredProjects = data.featuredProjects || [];

  const handleProjectClick = (link) => {
    window.open(link, "_blank");
  };

  const handleProjectMobileClick = (link) => {
    if (window.innerWidth < 770) {
      window.open(link, "_blank");
    }
  };

  return (
    <div className="builds-container" id="work">
      <Fade delay={100}>
        <div className="section-header-text">
          <span className="section-header-num">03.</span>
          Remarkable projects
        </div>
      </Fade>

      <div className="builds-content">
        {featuredProjects.map((project, index) => {
          const isLeftLayout = project.layout === "left";
          const delay = 200 + index * 100;

          return (
            <Fade key={project.id} delay={delay}>
              <div className="build">
                {isLeftLayout ? (
                  <>
                    <div className="left-build">
                      <div
                        className="build-image"
                        onClick={() => handleProjectClick(project.link)}
                      >
                        <img src={project.image} alt={project.name} />
                      </div>
                    </div>
                    <div
                      className="right-build"
                      onClick={() => handleProjectMobileClick(project.link)}
                    >
                      <div className="build-featured">Featured Project</div>
                      <div className="build-name">{project.name}</div>
                      <div className="build-desc">{project.description}</div>
                      <div className="build-tech top-tech">
                        <ul>
                          {project.technologies.map((tech, techIndex) => (
                            <li key={techIndex}>{tech}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="right-build"
                      onClick={() => handleProjectMobileClick(project.link)}
                    >
                      <div
                        className="build-featured"
                        style={{ textAlign: "left" }}
                      >
                        Featured Project
                      </div>
                      <div className="build-name" style={{ textAlign: "left" }}>
                        {project.name}
                      </div>
                      <div
                        className="build-desc"
                        style={{ left: "0px", textAlign: "left" }}
                      >
                        {project.description}
                      </div>
                      <div className="build-tech bot-tech">
                        <ul style={{ justifyContent: "flex-start" }}>
                          {project.technologies.map((tech, techIndex) => (
                            <li key={techIndex}>{tech}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="left-build">
                      <div
                        className="build-image"
                        onClick={() => handleProjectClick(project.link)}
                      >
                        <img src={project.image} alt={project.name} />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </Fade>
          );
        })}
      </div>
    </div>
  );
};

export default Builds;
